import React from 'react';

export interface LeagueFiltersState {
  nome: string;
  username: string;
  iuguConfigId: string;
}

export interface LeagueFiltersProps {
  filters: LeagueFiltersState;
  onChange: (filters: LeagueFiltersState) => void;
}

const LeagueFilters: React.FC<LeagueFiltersProps> = ({ filters, onChange }) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { name, value } = e.target;
    onChange({ ...filters, [name]: value });
  };

  const handleClear = () => {
    onChange({
      nome: '',
      username: '',
      iuguConfigId: '',
    });
  };

  return (
    <div className="row g-2 mb-3">
      <div className="col-md-4">
        <label htmlFor="nome">Nome da liga</label>
        <input
          type="text"
          name="nome"
          value={filters.nome}
          onChange={handleChange}
          className="form-control"
          placeholder="Pesquisar por nome"
        />
      </div>
      <div className="col-md-4">
        <label htmlFor="username">Username (slug)</label>
        <input
          type="text"
          name="username"
          value={filters.username}
          onChange={handleChange}
          className="form-control"
          placeholder="Pesquisar por username"
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="iuguConfigId">Configuração financeira (iuguConfigId)</label>
        <input
          type="text"
          name="iuguConfigId"
          value={filters.iuguConfigId}
          onChange={handleChange}
          className="form-control"
          placeholder="Opcional"
        />
      </div>
      <div className="col-md-1 d-flex align-items-end">
        <button
          type="button"
          className="btn btn-outline-secondary w-100"
          onClick={handleClear}
        >
          Limpar
        </button>
      </div>
    </div>
  );
};

export default LeagueFilters;







